import ApiHelper from 'api-helper';
import { TreatmentEpisode, TreatmentEpisodeMemo } from '@/models/treatment-episode';

export async function fetchTreatmentEpisodesApi(patientId: number | string): Promise<TreatmentEpisode[]> {
  const response = await ApiHelper.getApi('PatientTreatmentHistoryApi').getTreatmentEpisodes(patientId);
  return response.data || response || [];
}

export async function updateTreatmentEpisodeMemoApi(
  patientId: number | string,
  episodeId: number | string,
  content: string,
): Promise<TreatmentEpisodeMemo | null> {
  // The endpoint answers with `{ memo: <object|null> }` — null when the box was
  // cleared. The key matters: a bare null body would reach us as `{}`, which is
  // truthy and indistinguishable from a saved memo.
  const response = await ApiHelper.getApi('PatientTreatmentHistoryApi')
    .updateTreatmentEpisodeMemo(patientId, episodeId, content);
  return (response && response.memo) || null;
}
